import type { InjectionKey } from 'vue'

export interface ElementalMainListContext {
  id: string
}

export const ElementalMainListContextKey = Symbol(
  'ElementalMainListContext',
) as InjectionKey<ElementalMainListContext>

export function useElementalMainListContext() {
  return inject(ElementalMainListContextKey, null)
}
